/******************************************************
 *                  Open-iti export
 ********************************************************/
"use strict";

import dayjs from "dayjs";

angular.module("exploitation")

	.controller("CoursesSpecialesCtrlNew", ["$scope", "toastr", "companies", "CoursesSpecialesService", "$location",
		function ($scope, toastr, companies, CoursesSpecialesService, $location) {

		var dateToday = new Date();
		dateToday.setMilliseconds(0);
		dateToday.setSeconds(0);

		//Initialisation de l'objet à poster
		$scope.data = {
			stops: [],
			serviceDate: dateToday,
			serviceTime: dateToday,
			arrival: {
				dateArrival: dateToday,
				timeArrival: dateToday
			},
			departure: {
				dateDeparture: dateToday,
				timeDeparture: dateToday
			},
			companies: companies.data
		};

		function createCalendarParams() {
			$scope.calendar = [];

			for (var i = 0; i <= 2; i++) {
				$scope.calendar[i] = {
					opened: {
						start: false,
						end: false,
						service: false
					},
					open: function ($event, which, numCalendarParam) {
						$event.preventDefault();
						$event.stopPropagation();
						$scope.calendar[numCalendarParam].opened[which] = true;
					}
				};
			}
		}


		/**
         * Si changement d'état de la date de service
         */
		$scope.$watch("data.serviceDate", function () {
			if (dateDepartureFormat() < serviceDateFormat()) {
				$scope.data.departure.dateDeparture = $scope.data.serviceDate;
			}
		});


		function dateDepartureFormat() {
			if (!dayjs($scope.data.departure.dateDeparture).isValid()) {
				return dayjs($scope.data.departure.dateDeparture, "DD/MM/YYYY");
			} else {
				return dayjs($scope.data.departure.dateDeparture);
			}
		}

		function dateArrivalFormat() {
			if (!dayjs($scope.data.arrival.arrivalDate).isValid()) {
				return dayjs($scope.data.arrival.arrivalDate, "DD/MM/YYYY");
			} else {
				return dayjs($scope.data.arrival.arrivalDate);
			}
		}

		function serviceDateFormat() {
			if (!dayjs($scope.data.serviceDate).isValid()) {
				return dayjs($scope.data.serviceDate, "DD/MM/YYYY");
			} else {
				return dayjs($scope.data.serviceDate);
			}
		}

		/**
         * Si changement d'état de la date de départ de la CS
         */
		$scope.$watch("data.departure.dateDeparture", function (newValue, oldValue) {
			console.log("changement date départ");
			if (dateArrivalFormat() < dateDepartureFormat()) {
				$scope.data.arrival.dateArrival = $scope.data.departure.dateDeparture;
			}
		});


		/**
         * Créer une nouvelle course spéciale
         * @param data
         */
		$scope.postCourseSpeciale = function (data) {
			$scope.data.serviceDatetime = getIsoDateTime($scope.data.serviceDate, $scope.data.serviceTime);

			$scope.data.departure.datetimeDeparture = getIsoDateTime($scope.data.departure.dateDeparture, $scope.data.departure.timeDeparture);
			$scope.data.departure.datetimeArrival = $scope.data.departure.datetimeDeparture;

			$scope.data.arrival.datetimeArrival = getIsoDateTime($scope.data.arrival.dateArrival, $scope.data.arrival.timeArrival);
			$scope.data.arrival.datetimeDeparture = $scope.data.arrival.datetimeArrival;

			$scope.data.stops.push($scope.data.departure);
			$scope.data.stops.push($scope.data.arrival);

			CoursesSpecialesService.postCourseSpeciale(data)
				.then(() => {
					toastr.success("", "La course spéciale a bien été ajoutée");
					$location.path("/e-iti/course-speciale");
				})
				.catch((error) => {
					const data = error.data;
					var errorMessage = "Problème lors de la création de la course spéciale.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");

					// Enlever le point de départ et d'arriver des étapes
					$scope.data.stops.pop(); //Depart
					$scope.data.stops.pop(); //Arrivé
				});
		};


		/**
         * Avoir un format de date correct
         * @param date
         * @returns {string}
         */
		function getIsoDateTime(date, time) {
			return dayjs(date)
				.hour(time.getHours())
				.minute(time.getMinutes())
				.second(0)
				.millisecond(0)
				.toISOString();
		}


		// INITIALISATIOn
		createCalendarParams();

	}]);
